<template>
    <div class="scheme-details-box" v-if="Object.keys(this.form).length">
        <div class="head-box">
            <navBar></navBar>
        </div>
        <div class="content">
            <!-- 上上参谋企业版解决方案 -->
            <div class="banner-box">
                <div class="bag">
                    <img v-img="{ form: form.bannerObj, key: 'img' }" :src="form.bannerObj.img" alt="" />
                </div>
                <div class="container1">
                    <div class="img-text">
                        <div class="left-box wow fadeInUp">
                            <div class="name" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</div>
                            <div class="tip-text" v-edit="{ form: form.bannerObj, key: 'content' }">{{ form.bannerObj.content }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="head-tab-module wow fadeInUp">
                <div class="container1">
                    <div class="tab-content">
                        <div
                            class="tab-module head-tab-module-cell"
                            :class="{ 'active-tab': index === activeName }"
                            v-for="(item, index) in form.fitstObj.list"
                            :key="index"
                            @click="getInformation(index)"
                        >
                            <img v-if="index === activeName" :src="item.activeImg" v-img="{ form: item, key: 'activeImg' }" />
                            <img v-else :src="item.img" v-img="{ form: item, key: 'img' }" />
                            <div class="tab-text font18" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="activeName == 0">
                <!-- 业务挑战 -->
                <div class="cell-box">
                    <div class="container-box-title" v-edit="{ form: form, key: 'title' }">{{ form.secondObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.secondObj.list0" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 拓店云应用价值 -->
                <div class="drink">
                    <div class="drink-title" v-edit="{ form: form.thirdObj, key: 'title0' }">{{ form.thirdObj.title0 }}</div>
                    <div class="drink-content">
                        <div class="drink-content-item" v-for="(item, index) in form.thirdObj.list0" :key="index">
                            <div class="drink-content-item-content" v-edit="{ form: item, key: 'content' }">{{ item.content }}</div>
                            <div class="drink-content-item-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <!-- 拓店云应用优势 -->
                <div class="cell-box container-box">
                    <div class="container-box-title" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.fourthObj.list0" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 客户声音 -->
                <div class="user" :style="'background:url(' + form.fifthObj.src + '); backgroundSize: cover'" v-img="{ form: form.fifthObj, key: 'src' }">
                    <div class="container-box-title" style="color: #fff" v-edit="{ form: form.fifthObj, key: 'title' }">{{ form.fifthObj.title }}</div>
                    <div class="user-content">
                        <div class="user-content-box">
                            <div class="name-logo-box">
                                <div class="head-portrait">
                                    <img class="head-portrait-img" v-img="{ form: form.fifthObj.obj0, key: 'photo' }" :src="form.fifthObj.obj0.photo" />
                                    <div class="name-introduction">
                                        <div class="name font24" v-edit="{ form: form.fifthObj.obj0, key: 'title' }">{{ form.fifthObj.obj0.title }}</div>
                                        <div class="introduction" v-edit="{ form: form.fifthObj.obj0, key: 'smallTitle' }">{{ form.fifthObj.obj0.smallTitle }}</div>
                                    </div>
                                </div>
                                <div class="r-logo-img" v-img="{ form: form.fifthObj.obj0, key: 'logo' }"><img :src="form.fifthObj.obj0.logo" /></div>
                            </div>
                            <div class="introduction-content-box">
                                <div class="introduction-content" v-edit="{ form: form.fifthObj.obj0, key: 'content' }">{{ form.fifthObj.obj0.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 代表合作品牌 -->
                <div class="tabs-box logo-plate" id="home-logo-plate-box">
                    <div class="fadeInUp">
                        <div class="container-box-title font40" v-edit="{ form: form.seventhObj, key: 'title0' }">{{ form.seventhObj.title0 }}</div>
                    </div>
                    <div class="tabs-content-box fadeInUp grow-up-together">
                        <div class="logo-list">
                            <div v-for="(item, index) in form.seventhObj.list0" :key="index">
                                <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                                <itemAdd :list="form.seventhObj.list0" :itemIndex="index"></itemAdd>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="activeName === 1">
                <!-- 业务挑战 -->
                <div class="cell-box">
                    <div class="container-box-title" v-edit="{ form: form, key: 'title' }">{{ form.secondObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.secondObj.list1" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 拓店云应用价值 -->
                <div class="drink">
                    <div class="drink-title" v-edit="{ form: form.thirdObj, key: 'title1' }">{{ form.thirdObj.title1 }}</div>
                    <div class="drink-content">
                        <div class="drink-content-item" v-for="(item, index) in form.thirdObj.list1" :key="index">
                            <div class="drink-content-item-content" v-edit="{ form: item, key: 'content' }">{{ item.content }}</div>
                            <div class="drink-content-item-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <!-- 拓店云应用优势 -->
                <div class="cell-box container-box">
                    <div class="container-box-title" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.fourthObj.list1" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 客户声音 -->
                <div class="user" :style="'background:url(' + form.fifthObj.src + '); backgroundSize: cover'" v-img="{ form: form.fifthObj, key: 'src' }">
                    <div class="container-box-title" style="color: #fff" v-edit="{ form: form.fifthObj, key: 'title' }">{{ form.fifthObj.title }}</div>
                    <div class="user-content">
                        <div class="user-content-box">
                            <div class="name-logo-box">
                                <div class="head-portrait">
                                    <img class="head-portrait-img" v-img="{ form: form.fifthObj.obj1, key: 'photo' }" :src="form.fifthObj.obj1.photo" />
                                    <div class="name-introduction">
                                        <div class="name font24" v-edit="{ form: form.fifthObj.obj1, key: 'title' }">{{ form.fifthObj.obj1.title }}</div>
                                        <div class="introduction" v-edit="{ form: form.fifthObj.obj1, key: 'smallTitle' }">{{ form.fifthObj.obj1.smallTitle }}</div>
                                    </div>
                                </div>
                                <div class="r-logo-img" v-img="{ form: form.fifthObj.obj1, key: 'logo' }"><img :src="form.fifthObj.obj1.logo" /></div>
                            </div>
                            <div class="introduction-content-box">
                                <div class="introduction-content" v-edit="{ form: form.fifthObj.obj1, key: 'content' }">{{ form.fifthObj.obj1.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 代表合作品牌 -->
                <div class="tabs-box logo-plate" id="home-logo-plate-box">
                    <div class="fadeInUp">
                        <div class="container-box-title font40" v-edit="{ form: form.seventhObj, key: 'title1' }">{{ form.seventhObj.title1 }}</div>
                    </div>
                    <div class="tabs-content-box fadeInUp grow-up-together">
                        <div class="logo-list">
                            <div v-for="(item, index) in form.seventhObj.list1" :key="index">
                                <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                                <itemAdd :list="form.seventhObj.list1" :itemIndex="index"></itemAdd>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="activeName === 2">
                <!-- 业务挑战 -->
                <div class="cell-box">
                    <div class="container-box-title" v-edit="{ form: form, key: 'title' }">{{ form.secondObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.secondObj.list2" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 拓店云应用价值 -->
                <div class="drink">
                    <div class="drink-title" v-edit="{ form: form.thirdObj, key: 'title2' }">{{ form.thirdObj.title2 }}</div>
                    <div class="drink-content">
                        <div class="drink-content-item" v-for="(item, index) in form.thirdObj.list2" :key="index">
                            <div class="drink-content-item-content" v-edit="{ form: item, key: 'content' }">{{ item.content }}</div>
                            <div class="drink-content-item-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <!-- 拓店云应用优势 -->
                <div class="cell-box container-box">
                    <div class="container-box-title" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.fourthObj.list2" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 客户声音 -->
                <div class="user" :style="'background:url(' + form.fifthObj.src + '); backgroundSize: cover'" v-img="{ form: form.fifthObj, key: 'src' }">
                    <div class="container-box-title" style="color: #fff" v-edit="{ form: form.fifthObj, key: 'title' }">{{ form.fifthObj.title }}</div>
                    <div class="user-content">
                        <div class="user-content-box">
                            <div class="name-logo-box">
                                <div class="head-portrait">
                                    <img class="head-portrait-img" v-img="{ form: form.fifthObj.obj2, key: 'photo' }" :src="form.fifthObj.obj2.photo" />
                                    <div class="name-introduction">
                                        <div class="name font24" v-edit="{ form: form.fifthObj.obj2, key: 'title' }">{{ form.fifthObj.obj2.title }}</div>
                                        <div class="introduction" v-edit="{ form: form.fifthObj.obj2, key: 'smallTitle' }">{{ form.fifthObj.obj2.smallTitle }}</div>
                                    </div>
                                </div>
                                <div class="r-logo-img" v-img="{ form: form.fifthObj.obj2, key: 'logo' }"><img :src="form.fifthObj.obj2.logo" /></div>
                            </div>
                            <div class="introduction-content-box">
                                <div class="introduction-content" v-edit="{ form: form.fifthObj.obj2, key: 'content' }">{{ form.fifthObj.obj2.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 代表合作品牌 -->
                <div class="tabs-box logo-plate" id="home-logo-plate-box">
                    <div class="fadeInUp">
                        <div class="container-box-title font40" v-edit="{ form: form.seventhObj, key: 'title2' }">{{ form.seventhObj.title2 }}</div>
                    </div>
                    <div class="tabs-content-box fadeInUp grow-up-together">
                        <div class="logo-list">
                            <div v-for="(item, index) in form.seventhObj.list2" :key="index">
                                <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                                <itemAdd :list="form.seventhObj.list2" :itemIndex="index"></itemAdd>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="activeName === 3">
                <!-- 业务挑战 -->
                <div class="cell-box">
                    <div class="container-box-title" v-edit="{ form: form, key: 'title' }">{{ form.secondObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.secondObj.list3" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 拓店云应用价值 -->
                <div class="drink">
                    <div class="drink-title" v-edit="{ form: form.thirdObj, key: 'title3' }">{{ form.thirdObj.title3 }}</div>
                    <div class="drink-content">
                        <div class="drink-content-item" v-for="(item, index) in form.thirdObj.list3" :key="index">
                            <div class="drink-content-item-content" v-edit="{ form: item, key: 'content' }">{{ item.content }}</div>
                            <div class="drink-content-item-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <!-- 拓店云应用优势 -->
                <div class="cell-box container-box">
                    <div class="container-box-title" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</div>
                    <div class="container1">
                        <div class="module-box">
                            <div class="flexWarp">
                                <div v-for="(item, key) in form.fourthObj.list3" :key="key" class="module wow fadeInUp">
                                    <div class="default-img" v-img="{ form: item, key: 'img' }"><img class="b-img" :src="item.img" /></div>
                                    <div class="default-text">
                                        <div class="module-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                        <div class="tips textflow4" v-edit="{ form: item, key: 'content' }">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 客户声音 -->
                <div class="user" :style="'background:url(' + form.fifthObj.src + '); backgroundSize: cover'" v-img="{ form: form.fifthObj, key: 'src' }">
                    <div class="container-box-title" style="color: #fff" v-edit="{ form: form.fifthObj, key: 'title' }">{{ form.fifthObj.title }}</div>
                    <div class="user-content">
                        <div class="user-content-box">
                            <div class="name-logo-box">
                                <div class="head-portrait">
                                    <img class="head-portrait-img" v-img="{ form: form.fifthObj.obj3, key: 'photo' }" :src="form.fifthObj.obj3.photo" />
                                    <div class="name-introduction">
                                        <div class="name font24" v-edit="{ form: form.fifthObj.obj3, key: 'title' }">{{ form.fifthObj.obj3.title }}</div>
                                        <div class="introduction" v-edit="{ form: form.fifthObj.obj3, key: 'smallTitle' }">{{ form.fifthObj.obj3.smallTitle }}</div>
                                    </div>
                                </div>
                                <div class="r-logo-img" v-img="{ form: form.fifthObj.obj3, key: 'logo' }"><img :src="form.fifthObj.obj3.logo" /></div>
                            </div>
                            <div class="introduction-content-box">
                                <div class="introduction-content" v-edit="{ form: form.fifthObj.obj3, key: 'content' }">{{ form.fifthObj.obj3.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 饮品奶茶行业 - 代表合作品牌 -->
                <div class="tabs-box logo-plate" id="home-logo-plate-box">
                    <div class="fadeInUp">
                        <div class="container-box-title font40" v-edit="{ form: form.seventhObj, key: 'title3' }">{{ form.seventhObj.title3 }}</div>
                    </div>
                    <div class="tabs-content-box fadeInUp grow-up-together">
                        <div class="logo-list">
                            <div v-for="(item, index) in form.seventhObj.list3" :key="index">
                                <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                                <itemAdd :list="form.seventhObj.list3" :itemIndex="index"></itemAdd>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 想要了解更多信息或寻求商务合作 -->
            <div class="cooperation-box" v-img="{ form: form.sixthObj, key: 'img' }" :style="'background-image: url(' + form.sixthObj.img + ')'">
                <div class="container1">
                    <div class="cooperation-content">
                        <div class="cooperation-text">
                            <p class="cooperation-text-title" v-edit="{ form: form.sixthObj, key: 'title' }">{{ form.sixthObj.title }}</p>
                        </div>
                        <div class="cooperation-btn" @click="visible = true">立即咨询</div>
                    </div>
                </div>
            </div>
        </div>
        <submit-form :form="form" :refComponentId="163" :id="138"></submit-form>
        <guidance :type="2" :show="show" @hiddenToggle="hiddenToggle"></guidance>
        <form-dialog v-if="visible" @close="visible = false"></form-dialog>
    </div>
</template>

<script>
import navBar from '../../components/cloudNavBar.vue';
import { initWow } from '@/utils/wow';
import { pageQuery } from '@/api';
import submitForm from '../../components/submit-form.vue';
import Guidance from '@/components/guidance.vue';
import formDialog from '../../components/formDialog.vue';
import itemAdd from '@/components/item-add.vue';

export default {
    name: '',
    data() {
        return {
            show: false,
            activeName: 0,
            managementTool: '可视化战略布局',
            bigData: '城市宏观数据分析',
            fitModel: '网规模型',
            ModuleActive: 0,
            timer: null,
            domShow: false,
            visible: false, //免费试用弹出窗
            hezuo: {
                src: require('../../assets/cloudHome/contact_bg.jpg')
            },
            form: {},
            // form: {
            //     bannerObj: {
            //         img: require('../../assets/schemeDetails/banner_solu.png'),
            //         title: '行业标杆案例',
            //         content: '上上参谋企业版为不同行业、不同门店形态的连锁品牌提供开店决策支持帮助连锁品牌开店成功率、降低闭店率，降本增效'
            //     },
            //     fitstObj: {
            //         list: [
            //             {
            //                 img: require('../../assets/schemeDetails/icon_scheme_01.png'),
            //                 activeImg: require('../../assets/schemeDetails/icon_scheme_active01.png'),
            //                 title: '饮品奶茶'
            //             },
            //             {
            //                 img: require('../../assets/schemeDetails/icon_scheme_02.png'),
            //                 activeImg: require('../../assets/schemeDetails/icon_scheme_active02.png'),
            //                 title: '咖啡烘焙'
            //             },
            //             {
            //                 img: require('../../assets/schemeDetails/icon_scheme_03.png'),
            //                 activeImg: require('../../assets/schemeDetails/icon_scheme_active03.png'),
            //                 title: '小吃快餐'
            //             },
            //             {
            //                 img: require('../../assets/schemeDetails/icon_scheme_04.png'),
            //                 activeImg: require('../../assets/schemeDetails/icon_scheme_active04.png'),
            //                 title: '商超便利'
            //             }
            //         ]
            //     },
            //     secondObj: {
            //         title: '业务挑战',
            //         list0: [
            //             {
            //                 title: '拓店业务全局掌控难',
            //                 content: '无法实时查看在营店铺、竞对协同品牌在全国分布的情况，决策层对业务宏观进度了解存在时效性',
            //                 img: require('../../assets/schemeDetails/icon_scheme_05.png')
            //             },
            //             {
            //                 title: '系统化选址评估策略薄弱',
            //                 content: '对于团队的专业能力依赖性强，成功方法论难以复制，帮助加盟商选好址、评好铺',
            //                 img: require('../../assets/schemeDetails/icon_scheme_06.png')
            //             },
            //             {
            //                 title: '业务资产留存困难',
            //                 content: '勘店、加盟商带看，无法实时获取拓店人员工作完成情况',
            //                 img: require('../../assets/schemeDetails/icon_scheme_07.png')
            //             },
            //             {
            //                 title: '实勘内容多、团队任务重',
            //                 content: '线下勘店过程中，需要收录的信息复杂多样，传统的信息采集方式效率低',
            //                 img: require('../../assets/schemeDetails/icon_scheme_08.png')
            //             }
            //         ],
            //         list1: [
            //             {
            //                 title: '拓店业务全局掌控难1',
            //                 content: '无法实时查看在营店铺、竞对协同品牌在全国分布的情况，决策层对业务宏观进度了解存在时效性',
            //                 img: require('../../assets/schemeDetails/icon_scheme_05.png')
            //             },
            //             {
            //                 title: '系统化选址评估策略薄弱1',
            //                 content: '对于团队的专业能力依赖性强，成功方法论难以复制，帮助加盟商选好址、评好铺',
            //                 img: require('../../assets/schemeDetails/icon_scheme_06.png')
            //             },
            //             {
            //                 title: '业务资产留存困难1',
            //                 content: '勘店、加盟商带看，无法实时获取拓店人员工作完成情况',
            //                 img: require('../../assets/schemeDetails/icon_scheme_07.png')
            //             },
            //             {
            //                 title: '实勘内容多、团队任务重1',
            //                 content: '线下勘店过程中，需要收录的信息复杂多样，传统的信息采集方式效率低',
            //                 img: require('../../assets/schemeDetails/icon_scheme_08.png')
            //             }
            //         ],
            //         list2: [
            //             {
            //                 title: '拓店业务全局掌控难2',
            //                 content: '无法实时查看在营店铺、竞对协同品牌在全国分布的情况，决策层对业务宏观进度了解存在时效性',
            //                 img: require('../../assets/schemeDetails/icon_scheme_05.png')
            //             },
            //             {
            //                 title: '系统化选址评估策略薄弱2',
            //                 content: '对于团队的专业能力依赖性强，成功方法论难以复制，帮助加盟商选好址、评好铺',
            //                 img: require('../../assets/schemeDetails/icon_scheme_06.png')
            //             },
            //             {
            //                 title: '业务资产留存困难2',
            //                 content: '勘店、加盟商带看，无法实时获取拓店人员工作完成情况',
            //                 img: require('../../assets/schemeDetails/icon_scheme_07.png')
            //             },
            //             {
            //                 title: '实勘内容多、团队任务重2',
            //                 content: '线下勘店过程中，需要收录的信息复杂多样，传统的信息采集方式效率低',
            //                 img: require('../../assets/schemeDetails/icon_scheme_08.png')
            //             }
            //         ],
            //         list3: [
            //             {
            //                 title: '拓店业务全局掌控难3',
            //                 content: '无法实时查看在营店铺、竞对协同品牌在全国分布的情况，决策层对业务宏观进度了解存在时效性',
            //                 img: require('../../assets/schemeDetails/icon_scheme_05.png')
            //             },
            //             {
            //                 title: '系统化选址评估策略薄弱3',
            //                 content: '对于团队的专业能力依赖性强，成功方法论难以复制，帮助加盟商选好址、评好铺',
            //                 img: require('../../assets/schemeDetails/icon_scheme_06.png')
            //             },
            //             {
            //                 title: '业务资产留存困难3',
            //                 content: '勘店、加盟商带看，无法实时获取拓店人员工作完成情况',
            //                 img: require('../../assets/schemeDetails/icon_scheme_07.png')
            //             },
            //             {
            //                 title: '实勘内容多、团队任务重3',
            //                 content: '线下勘店过程中，需要收录的信息复杂多样，传统的信息采集方式效率低',
            //                 img: require('../../assets/schemeDetails/icon_scheme_08.png')
            //             }
            //         ]
            //     },
            //     thirdObj: {
            //         title0: '饮品奶茶行业 - 拓店云应用价值',
            //         title1: '饮品奶茶行业 - 拓店云应用价值1',
            //         title2: '饮品奶茶行业 - 拓店云应用价值2',
            //         title3: '饮品奶茶行业 - 拓店云应用价值3',
            //         list0: [
            //             {
            //                 title: '平均开店效率',
            //                 content: '+3%'
            //             },
            //             {
            //                 title: '平均闭店率',
            //                 content: '-5%'
            //             },
            //             {
            //                 title: '平均人效提升',
            //                 content: '+8%'
            //             },
            //             {
            //                 title: '平均拓展成本',
            //                 content: '-3%'
            //             }
            //         ],
            //         list1: [
            //             {
            //                 title: '平均开店效率',
            //                 content: '+3%'
            //             },
            //             {
            //                 title: '平均闭店率',
            //                 content: '-5%'
            //             },
            //             {
            //                 title: '平均人效提升',
            //                 content: '+8%'
            //             },
            //             {
            //                 title: '平均拓展成本',
            //                 content: '-3%'
            //             }
            //         ],
            //         list2: [
            //             {
            //                 title: '平均开店效率',
            //                 content: '+3%'
            //             },
            //             {
            //                 title: '平均闭店率',
            //                 content: '-5%'
            //             },
            //             {
            //                 title: '平均人效提升',
            //                 content: '+8%'
            //             },
            //             {
            //                 title: '平均拓展成本',
            //                 content: '-3%'
            //             }
            //         ],
            //         list3: [
            //             {
            //                 title: '平均开店效率',
            //                 content: '+3%'
            //             },
            //             {
            //                 title: '平均闭店率',
            //                 content: '-5%'
            //             },
            //             {
            //                 title: '平均人效提升',
            //                 content: '+8%'
            //             },
            //             {
            //                 title: '平均拓展成本',
            //                 content: '-3%'
            //             }
            //         ]
            //     },
            //     fourthObj: {
            //         title: '拓店云应用优势',
            //         list0: [
            //             {
            //                 title: '全面的数据分析支持',
            //                 content: '从宏观到微观，多维度多类型数据分析支撑决策，兼顾拓店业务全流程、全周期',
            //                 img: require('../../assets/schemeDetails/icon_scheme_09.png')
            //             },
            //             {
            //                 title: '高效的单店模型建立',
            //                 content: '从宏观到微观，多维度多类型分析报告支撑决策，规避开店风险',
            //                 img: require('../../assets/schemeDetails/icon_scheme_10.png')
            //             },
            //             {
            //                 title: '及时的业务资产沉淀',
            //                 content: '勘店全线上流程，所有资料永久云端留存形成数据资产，人员工作情况实时掌握',
            //                 img: require('../../assets/schemeDetails/icon_scheme_11.png')
            //             },
            //             {
            //                 title: '便捷的信息采集应用',
            //                 content: '提供APP勘店工具，支持不同店型使用不同模板，满足前端作业的各类内容采集需求，提升作业人效',
            //                 img: require('../../assets/schemeDetails/icon_scheme_12.png')
            //             }
            //         ],
            //         list1: [
            //             {
            //                 title: '全面的数据分析支持1',
            //                 content: '从宏观到微观，多维度多类型数据分析支撑决策，兼顾拓店业务全流程、全周期',
            //                 img: require('../../assets/schemeDetails/icon_scheme_09.png')
            //             },
            //             {
            //                 title: '高效的单店模型建立',
            //                 content: '从宏观到微观，多维度多类型分析报告支撑决策，规避开店风险',
            //                 img: require('../../assets/schemeDetails/icon_scheme_10.png')
            //             },
            //             {
            //                 title: '及时的业务资产沉淀',
            //                 content: '勘店全线上流程，所有资料永久云端留存形成数据资产，人员工作情况实时掌握',
            //                 img: require('../../assets/schemeDetails/icon_scheme_11.png')
            //             },
            //             {
            //                 title: '便捷的信息采集应用',
            //                 content: '提供APP勘店工具，支持不同店型使用不同模板，满足前端作业的各类内容采集需求，提升作业人效',
            //                 img: require('../../assets/schemeDetails/icon_scheme_12.png')
            //             }
            //         ],
            //         list2: [
            //             {
            //                 title: '全面的数据分析支持2',
            //                 content: '从宏观到微观，多维度多类型数据分析支撑决策，兼顾拓店业务全流程、全周期',
            //                 img: require('../../assets/schemeDetails/icon_scheme_09.png')
            //             },
            //             {
            //                 title: '高效的单店模型建立',
            //                 content: '从宏观到微观，多维度多类型分析报告支撑决策，规避开店风险',
            //                 img: require('../../assets/schemeDetails/icon_scheme_10.png')
            //             },
            //             {
            //                 title: '及时的业务资产沉淀',
            //                 content: '勘店全线上流程，所有资料永久云端留存形成数据资产，人员工作情况实时掌握',
            //                 img: require('../../assets/schemeDetails/icon_scheme_11.png')
            //             },
            //             {
            //                 title: '便捷的信息采集应用',
            //                 content: '提供APP勘店工具，支持不同店型使用不同模板，满足前端作业的各类内容采集需求，提升作业人效',
            //                 img: require('../../assets/schemeDetails/icon_scheme_12.png')
            //             }
            //         ],
            //         list3: [
            //             {
            //                 title: '全面的数据分析支持3',
            //                 content: '从宏观到微观，多维度多类型数据分析支撑决策，兼顾拓店业务全流程、全周期',
            //                 img: require('../../assets/schemeDetails/icon_scheme_09.png')
            //             },
            //             {
            //                 title: '高效的单店模型建立',
            //                 content: '从宏观到微观，多维度多类型分析报告支撑决策，规避开店风险',
            //                 img: require('../../assets/schemeDetails/icon_scheme_10.png')
            //             },
            //             {
            //                 title: '及时的业务资产沉淀',
            //                 content: '勘店全线上流程，所有资料永久云端留存形成数据资产，人员工作情况实时掌握',
            //                 img: require('../../assets/schemeDetails/icon_scheme_11.png')
            //             },
            //             {
            //                 title: '便捷的信息采集应用',
            //                 content: '提供APP勘店工具，支持不同店型使用不同模板，满足前端作业的各类内容采集需求，提升作业人效',
            //                 img: require('../../assets/schemeDetails/icon_scheme_12.png')
            //             }
            //         ]
            //     },
            //     fifthObj: {
            //         src: require('@/assets/schemeDetails/banner_pro.png'),
            //         title: '客户声音',
            //         obj0: {
            //             photo: require('../../assets/img/2141950363.jpg'),
            //             title: '上上参谋企业版客户 夏先生',
            //             smallTitle: '第9味老上海馄饨 / 副总经理',
            //             logo: require('../../assets/img/logo2.png'),
            //             content:
            //                 '上上参谋企业版的智能化网规功能可以帮助我们更加精准地选择店址。通过大数据和先进算法的分析，系统可以考虑到各种市场因素，例如人口密度、消费能力、竞争情况等等，从而为我们确定最佳的开店位置。这不仅能够避免盲目选址和决策不准确的风险，而且还能够大大提高门店的存活率。',
            //             buttonContent: '立即咨询'
            //         },
            //         obj1: {
            //             photo: require('../../assets/img/2141950363.jpg'),
            //             title: '上上参谋企业版客户 夏先生1',
            //             smallTitle: '第9味老上海馄饨 / 副总经理',
            //             logo: require('../../assets/img/logo2.png'),
            //             content:
            //                 '上上参谋企业版的智能化网规功能可以帮助我们更加精准地选择店址。通过大数据和先进算法的分析，系统可以考虑到各种市场因素，例如人口密度、消费能力、竞争情况等等，从而为我们确定最佳的开店位置。这不仅能够避免盲目选址和决策不准确的风险，而且还能够大大提高门店的存活率。',
            //             buttonContent: '立即咨询'
            //         },
            //         obj2: {
            //             photo: require('../../assets/img/2141950363.jpg'),
            //             title: '上上参谋企业版客户 夏先生2',
            //             smallTitle: '第9味老上海馄饨 / 副总经理',
            //             logo: require('../../assets/img/logo2.png'),
            //             content:
            //                 '上上参谋企业版的智能化网规功能可以帮助我们更加精准地选择店址。通过大数据和先进算法的分析，系统可以考虑到各种市场因素，例如人口密度、消费能力、竞争情况等等，从而为我们确定最佳的开店位置。这不仅能够避免盲目选址和决策不准确的风险，而且还能够大大提高门店的存活率。',
            //             buttonContent: '立即咨询'
            //         },
            //         obj3: {
            //             photo: require('../../assets/img/2141950363.jpg'),
            //             title: '上上参谋企业版客户 夏先生3',
            //             smallTitle: '第9味老上海馄饨 / 副总经理',
            //             logo: require('../../assets/img/logo2.png'),
            //             content:
            //                 '上上参谋企业版的智能化网规功能可以帮助我们更加精准地选择店址。通过大数据和先进算法的分析，系统可以考虑到各种市场因素，例如人口密度、消费能力、竞争情况等等，从而为我们确定最佳的开店位置。这不仅能够避免盲目选址和决策不准确的风险，而且还能够大大提高门店的存活率。',
            //             buttonContent: '立即咨询'
            //         }
            //     },
            //     sixthObj: {
            //         img: require('../../assets/cloudHome/contact_bg.png'),
            //         title: '全国拓展、好店复制，就用上上参谋企业版',
            //         content: '立即咨询'
            //     },
            //     seventhObj: {
            //         title_0: '饮品奶茶行业 - 代表合作品牌',
            //         title_1: '饮品奶茶行业 - 代表合作品牌1',
            //         title_2: '饮品奶茶行业 - 代表合作品牌2',
            //         title_3: '饮品奶茶行业 - 代表合作品牌3',
            //         list0: [
            //             {
            //                 img: require('@/assets/logo/1.png')
            //             }
            //         ],
            //         list1: [
            //             {
            //                 img: require('@/assets/logo/1.png')
            //             }
            //         ],
            //         list2: [
            //             {
            //                 img: require('@/assets/logo/1.png')
            //             }
            //         ],
            //         list3: [
            //             {
            //                 img: require('@/assets/logo/1.png')
            //             }
            //         ]
            //     },
            //     title: '便利店行业-发展背景',
            //     text1: '您好，我是您的专属产品顾问',
            //     text2: '扫码添加微信',
            //     text3: '我将及时为您答疑'
            // }
        };
    },
    mounted() {
        let idx = this.$route.query.activeName || 0;
        this.activeName = Number(idx);
        pageQuery({ componentId: '163', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                initWow();
            });
            setTimeout(() => {
                this.tabHeaderInitialize('scale-development');
                $('#scale-development .el-tabs .el-tabs__item').hover(
                    e => {
                        $(e.currentTarget).click();
                    },
                    e => {}
                );
            }, 500);
        });
    },
    methods: {
        getInformation(idx) {
            this.activeName = idx;
        },
        showToggle() {
            if (this.$store.state.token) return;
            this.show = true;
        },
        hiddenToggle() {
            this.show = false;
        },
        jumpPage(target, way) {
            if (this.$store.state.token) {
                return;
            }
            if (way == 'router') {
                this.$router.push({
                    name: target
                });
            } else if (way == 'a') {
                window.location.href = target;
            }
        },
        tabHeaderInitialize(idName = 'home-user-selection-tabs-box') {
            let dom = $('#' + idName + ' .el-tabs__header .el-tabs__nav-scroll');
            let h = dom.find('.el-tabs__item').innerHeight();
            let w = dom.find('.el-tabs__item').innerWidth();
            dom.append(`<div class="slider" style="height:${h}px;width: ${w}px;background-color: #eb5405;border-radius: 50px;"></div>`);

            dom.find('.el-tabs__item').click((e) => {
                let idText = $(e.currentTarget).attr('id');
                let index = idText.split('tab-')[1];
                let sliderDom = $(e.currentTarget).parent().next();
                sliderDom.css({
                    transform: `translateX(${w * index}px)`
                });
            });
        }
    },
    components: { navBar, submitForm, Guidance, formDialog, itemAdd }
};
</script>

<style scoped lang="less">
@-webkit-keyframes moduleUp {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }

    50% {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
}
.scheme-details-box {
    width: 100%;
    position: relative;
    .head-box {
        width: 100%;
        height: auto !important;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: rgba(255, 255, 255, 1);
    }
    .content {
        width: 100%;
        .banner-box {
            width: 100%;
            height: 820px;
            background-size: cover;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            margin-top: 69px;
            overflow: hidden;
            @media @max-lg {
                height: 520px;
            }
            .bag {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    @media @max-xs {
                        width: 100%;
                    }
                }
            }
            .img-text {
                position: relative;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10;

                .left-box {
                    color: #fff;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    .name {
                        font-size: 60px;
                        font-family: 'PingFang-Bold' !important;
                        @media @max-lg {
                            font-size: 30px;
                        }
                        @media @max-sm {
                            font-size: 20px;
                        }
                    }

                    .tip-text {
                        max-width: 680px;
                        text-align: center;
                        font-size: 24px;
                        margin-top: 20px;
                        font-family: 'PingFang-Regular' !important;
                        @media @max-lg {
                            font-size: 18px;
                        }
                        @media @max-sm {
                            font-size: 14px;
                        }
                    }
                    .button-box {
                        margin-top: 0;
                        display: flex;
                    }
                }
            }
        }

        .head-tab-module {
            width: 100%;
            margin-top: -110px;
            position: relative;
            z-index: 2;
            @media @max-lg {
                margin-top: -80px;
            }
            @media @max-sm {
                margin-top: -50px;
            }
            .tab-content {
                display: flex;
                justify-content: center;
                align-items: center;
                color: #8d8d8d;
                background-color: #fff;
                box-shadow: 0 0px 14px 0px rgba(198, 198, 198, 0.6);
                transition: all 0.4s;
                .tab-module {
                    flex: 1;
                    height: 210px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    @media @max-lg {
                        height: 160px;
                    }
                    @media @max-sm {
                        height: 126px;
                    }
                    img {
                        width: auto;
                        height: 84px;
                        @media @max-lg {
                            height: 56px;
                        }
                        @media @max-sm {
                            height: 36px;
                        }
                    }
                    .tab-text {
                        font-size: 24px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        margin-top: 32px;
                        @media @max-lg {
                            font-size: 18px;
                            margin-top: 18px;
                        }
                        @media @max-sm {
                            font-size: 12px;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
        .active-tab {
            color: #fff;
            background-color: #ff5d00;
        }

        .cell-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            padding-bottom: 108px;
            .box-title {
                color: #000;
                margin-bottom: 4px;
                font-family: 'PingFang-Heavy' !important;
            }
            .tips {
                color: #65697f;
                margin-bottom: 36px;
                @media @max-lg {
                    margin-bottom: 30px;
                }
                @media @max-xs {
                    margin-bottom: 24px;
                }
            }

            .module-box {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                .module {
                    flex: 0 0 48.5%;
                    height: 226px;
                    display: flex;
                    background-color: #fff;
                    box-shadow: 0px 2px 54px 0px rgba(17, 17, 17, 0.08);
                    margin-bottom: 46px;
                    border-radius: 8px;
                    position: relative;
                    overflow: hidden;
                    @media @max-lg {
                        height: 180px;
                        margin-bottom: 30px;
                    }
                    @media @max-sm {
                        flex: 0 0 100%;
                        height: 160px;
                        margin-bottom: 16px;
                    }
                    .default-img {
                        width: 32%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        .b-img {
                            width: 43.6%;
                            height: auto;
                            transition: all 0.8s;
                        }
                    }

                    .default-text {
                        height: 100%;
                        position: absolute;
                        bottom: 0;
                        left: 32%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        border-radius: 8px;
                        .module-title {
                            font-size: 28px;
                            font-family: Source Han Sans CN;
                            font-weight: 500;
                            color: #333333;
                            line-height: 30px;
                            margin-bottom: 22px;
                            transition: all 0.8s;
                            @media @max-lg {
                                font-size: 22px;
                                margin-bottom: 14px;
                            }
                            @media @max-sm {
                                font-size: 16px;
                                margin-bottom: 8px;
                            }
                        }
                        .tips {
                            width: 78%;
                            font-size: 16px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #65697f;
                            line-height: 26px;
                            @media @max-lg {
                                font-size: 14px;
                            }
                            @media @max-sm {
                                font-size: 12px;
                            }
                        }
                    }
                }

                .module:last-child {
                    margin-right: 0;
                }
                .module:hover {
                    .b-img {
                        animation: moduleUp 2s ease forwards;
                    }
                    .module-title {
                        color: #eb5405;
                    }
                }
            }
        }
        .drink {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 320px;
            background: linear-gradient(145deg, #ff5d00, #fea402);
            .drink-title {
                font-size: 40px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
                line-height: 38px;
                text-align: center;
                @media @max-lg {
                    font-size: 28px;
                }
                @media @max-sm {
                    font-size: 18px;
                }
            }
            .drink-content {
                display: flex;
                justify-content: space-around;
                width: 87.5%;
                max-width: 1600px;
                margin-top: 48px;
                .drink-content-item {
                    width: 100%;
                    font-weight: 500;
                    font-family: Source Han Sans CN;
                    text-align: center;
                    color: #ffffff;
                    border-right: 3px solid rgba(254, 251, 249, 0.4);
                    .drink-content-item-content {
                        font-size: 60px;
                        @media @max-lg {
                            font-size: 42px;
                        }
                        @media @max-sm {
                            font-size: 28px;
                        }
                    }
                    .drink-content-item-title {
                        font-size: 24x;
                        @media @max-lg {
                            font-size: 18px;
                        }
                        @media @max-sm {
                            font-size: 12px;
                        }
                    }
                    &:last-child {
                        border: none;
                    }
                }
            }
        }
        .user {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: 108px;
            .user-content {
                width: 87.5%;
                max-width: 1600px;
                margin-top: 43px;
                background: #ffffff;
                .user-content-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .name-logo-box {
                        width: 71.25%;
                        margin-top: 62px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;
                        .head-portrait {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .head-portrait-img {
                                width: 100px;
                                height: auto;
                                border-radius: 50%;
                            }
                            .name-introduction {
                                margin-left: 15px;
                                .name {
                                    color: #121826;
                                    font-family: 'PingFang-Heavy' !important;
                                }
                                .introduction {
                                    font-size: 16px;
                                    color: #999999;
                                    font-family: 'PingFang-Regular' !important;
                                }
                            }
                        }
                        .r-logo-img {
                            width: 168px;
                            overflow: hidden;
                            @media @max-sm {
                                display: none;
                            }
                            img {
                                width: 100%;
                                float: left;
                            }
                        }
                    }
                    .introduction-content-box {
                        width: 82.25%;
                        min-height: 160px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-image: url('../../assets/cloudProduct/j2.png'), url('../../assets/cloudProduct/j1.png');
                        background-repeat: no-repeat, no-repeat;
                        background-position: 0px 0px, 100% bottom;
                        margin: 20px 0 60px 0;
                        .introduction-content {
                            width: 70%;
                            font-size: 18px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #8d8d8d;
                            line-height: 32px;
                        }
                    }
                }
            }
        }
        .cooperation-box {
            width: 100%;
            background-size: cover;
            padding: 35px 0;
            .container1 {
                display: flex;
                align-items: center;
                justify-content: center;
                .cooperation-content {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    width: 77%;
                    margin-bottom: -32px;
                    @media @max-xs {
                        justify-content: center;
                    }
                    .cooperation-text {
                        color: #fff;
                        font-family: Source Han Sans CN;
                        font-size: 36px;
                        font-weight: 500;
                        letter-spacing: 0;
                        flex-shrink: 0;
                        max-width: 100%;
                        margin-bottom: 32px;
                        @media @max-lg {
                            font-size: 30px;
                        }
                        @media @max-md {
                            font-size: 26px;
                        }
                        @media @max-xs {
                            text-align: center;
                            font-size: 20px;
                        }
                    }
                    .cooperation-btn {
                        width: 130px;
                        height: 45px;
                        background: #ffffff;
                        border-radius: 23px;
                        font-size: 20px;
                        font-family: MiSans;
                        font-weight: 500;
                        color: #ff5d00;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                        margin-bottom: 32px;
                    }
                    .contact-img {
                        position: relative;
                        margin-right: 120px;

                        @media @max-md {
                            margin-right: 60px;
                        }
                        @media @max-sm {
                            margin-top: 60px;
                            margin-right: 0;
                            margin: 60px auto 0;
                        }
                        img {
                            width: 260px;
                            height: auto;
                            object-fit: scale-down;
                            &:nth-child(2) {
                                position: absolute;
                                left: 82px;
                                width: 100px;
                                top: 84px;
                            }
                        }
                    }
                }
            }
        }
        .tabs-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: url('../../assets/img/b2.png') no-repeat;
            background-size: cover;
            text-align: center;
            .tabs-content-box {
                width: 87.5%;
                max-width: 1600px;
                border-radius: 8px;
                background-color: #fff;
                box-sizing: border-box;
                text-align: left;
                @media @max-sm {
                    padding: 30px;
                }
                .name-logo-box {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    @media @max-xs {
                        flex-wrap: wrap;
                    }
                    .head-portrait {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .head-portrait-img {
                            width: 100px;
                            height: 100px;
                            object-fit: cover;
                            border-radius: 50%;
                            object-fit: scale-down;
                            @media @max-xs {
                                width: 80px;
                                height: 80px;
                            }
                        }
                        .name-introduction {
                            margin-left: 15px;
                            .name {
                                color: #121826;
                            }
                            .introduction {
                                color: #999999;
                            }
                        }
                    }
                    .r-logo-img img {
                        max-height: 100px;
                        @media @max-xs {
                            margin-top: 20px;
                        }
                    }
                }
                .introduction-content {
                    width: 100%;
                    min-height: 170px;
                    margin-top: 40px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-image: url('../../assets/cloudProduct/qu_1.png'), url('../../assets/cloudProduct/qu_2.png');
                    background-repeat: no-repeat, no-repeat;
                    background-position: top left, 98.8% 92px;
                    .introduction {
                        max-width: 880px;
                        min-height: 114px;
                        text-align: left;
                        color: #7d89a1;
                        letter-spacing: 1px;
                        line-height: 1.5em;
                        word-break: break-all;
                    }
                }
            }
        }
        .logo-plate {
            background: #f2f4f6;
            padding-bottom: 108px;
            .box-title {
                color: #121826;
                margin-bottom: 4px;
            }
            .tips {
                color: #5a6779;
                margin-bottom: 32px;
            }
            .tabs-content-box {
                width: 83.3vw;
                @media @max-xs {
                    height: 240px;
                    overflow-y: auto;
                    padding: 0 !important;
                    min-height: auto;
                }
                .logo-list {
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    > div {
                        width: 12.5%;
                        height: 14.28%;
                        max-height: 78px;
                    }
                    img {
                        width: 100%;
                        height: auto;
                        max-height: 78px;
                        object-fit: scale-down;
                        // @media @max-xs {
                        //     width: 33.333%;
                        //     height: 60px;
                        // }
                    }
                }
            }
        }
    }
    .container-box {
        height: 800px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .container-box-title {
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #252525;
        line-height: 39px;
        margin: 80px 0 60px;
        text-align: center;
        @media @max-sm {
            font-size: 32px;
            margin: 60px 0 40px;
        }
        @media @max-xx {
            font-size: 24px;
            margin: 30px 0 20px;
        }
    }
}

.textflow4 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    word-break: break-all;
}

// 弹窗
.sc-mask {
    width: 100%;
    position: fixed;
    height: 100%;
    // display: none;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 999;
}

.sc-windows {
    // display: none;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    transition: all 0.3s;
    .c-close {
        position: absolute;
        left: calc(100% + 20px);
        top: 0;
        cursor: pointer;
        width: 50px;
        height: 50px;
        @media @max-lg {
            width: 40px;
            height: 40px;
        }
        @media @max-xs {
            left: 50%;
            top: 105%;
            transform: translateX(-50%);
        }
        img {
            width: 100%;
            height: 100%;
        }
    }

    .c-box {
        background: #fff;
        border-radius: 10px;
        padding: 55px 55px 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .c-title {
            text-align: center;
            color: #333;
            margin-bottom: 20px;
        }
        .c-code {
            width: 210px;
            height: 210px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .c-text {
            margin-top: 20px;
            color: #ff5d00;
            text-align: center;
            @media (max-width: 990px) {
                font-size: 18px;
            }
        }
    }
}
</style>
